export default function Products() {
  const products = [
    {
      name: 'Leite de Cabra',
      description: 'Leite de cabra puro e fresco, rico em nutrientes e de fácil digestão, ideal para toda a família.',
      image: 'https://static.readdy.ai/image/7511a7cc259ce621d354b0ff71fdfe7c/d153092107102d05c358fe2a76c1dddf.png',
      icon: 'ri-drop-line'
    },
    {
      name: 'Queijo de Coalho Tradicional',
      description: 'Nosso clássico queijo de coalho feito com 100% leite de cabra, sabor autêntico e textura perfeita.',
      image: 'https://static.readdy.ai/image/7511a7cc259ce621d354b0ff71fdfe7c/a414a551c546413635f5d1eb01221317.jpeg',
      icon: 'ri-star-line'
    },
    {
      name: 'Queijo com Pimenta Calabresa',
      description: 'Combinação perfeita entre a suavidade do leite de cabra e o toque picante da pimenta calabresa.',
      image: 'https://static.readdy.ai/image/7511a7cc259ce621d354b0ff71fdfe7c/ea578c0e4f4188c38860a0a8c449c0ed.jpeg',
      icon: 'ri-fire-line'
    },
    {
      name: 'Queijo com Alecrim',
      description: 'Sabor aromático e refinado, com ervas frescas de alecrim que realçam a qualidade do leite de cabra.',
      image: 'https://static.readdy.ai/image/7511a7cc259ce621d354b0ff71fdfe7c/813204ff19bce362baed0367071dac13.jpeg',
      icon: 'ri-leaf-line'
    },
    {
      name: 'Queijo com Orégano',
      description: 'O toque mediterrâneo do orégano harmoniza perfeitamente com a cremosidade do nosso queijo.',
      image: 'https://static.readdy.ai/image/7511a7cc259ce621d354b0ff71fdfe7c/77feb9b4a5177b2cdefb27be64752d7a.jpeg',
      icon: 'ri-plant-line'
    },
    {
      name: 'Queijo com Canela',
      description: 'Inovação e tradição em um só produto, com o toque adocicado e aromático da canela.',
      image: 'https://static.readdy.ai/image/7511a7cc259ce621d354b0ff71fdfe7c/36815ce0d2766cfada53018af66edbc3.jpeg',
      icon: 'ri-contrast-drop-line'
    },
    {
      name: 'Iogurtes e Bebidas Lácteas',
      description: 'Em breve! Novos produtos em desenvolvimento para ampliar nosso portfólio de derivados lácteos.',
      image: 'https://public.readdy.ai/ai/img_res/008c9affa235080e343f6a76b4658d08.jpg',
      icon: 'ri-cup-line',
      comingSoon: true
    }
  ];

  return (
    <section id="produtos" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-green-800 mb-4">Nossos Produtos</h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Queijos de coalho de leite de cabra premiados, feitos com 100% leite caprino e seguindo rigorosos padrões de qualidade com inspeção federal (SIF)
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto" data-product-shop>
          {products.map((product, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="relative">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-64 object-cover object-top"
                />
                {product.comingSoon && (
                  <div className="absolute top-4 right-4 bg-amber-500 text-white px-4 py-2 rounded-full font-bold text-sm">
                    Em Breve
                  </div>
                )}
                <div className="absolute top-4 left-4 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md">
                  <i className={`${product.icon} text-2xl text-green-600`}></i>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-green-800 mb-3">{product.name}</h3>
                <p className="text-gray-700 leading-relaxed">{product.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-gradient-to-r from-green-600 to-green-700 rounded-lg p-8 max-w-4xl mx-auto text-center text-white shadow-xl">
          <div className="flex items-center justify-center mb-4">
            <i className="ri-shield-check-line text-5xl"></i>
          </div>
          <h3 className="text-2xl font-bold mb-4">Qualidade Certificada</h3>
          <p className="text-lg leading-relaxed">
            Todos os nossos produtos são feitos com <strong>leite 100% caprino</strong>, seguindo padrões rigorosos de qualidade e segurança com inspeção federal (SIF). Garantimos a excelência em cada etapa do processo produtivo.
          </p>
        </div>
      </div>
    </section>
  );
}
